<style scoped>
.bucket-list {
    display: block;
    padding: 0;
    margin: 0;
    list-style: none;
    white-space: nowrap;
    overflow: auto;
}

.bucket-list li {
    float: left;
    margin: 10px;
}

.bucket-list li:last-child {
    margin-right: 0;
}

.buckets {
    overflow: auto;
    margin: 10px 0;
}

.duplicate {
    color: red;
}

.deleteall {
    float: right;
    border: 1px solid black;
    padding: 10px;
    background: red;
    border-radius: 2px;
    color: white;
}

.active {
    background-color: burlywood;
    color: white;
}

.shadowBox {
    box-shadow: 0 1px 7px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(0, 0, 0, 0.04) !important;
    padding: 10px;
}

.shadowBox:hover .design-delete {
    display: inline-block !important;
}

.dbuttondiv {
    float: right;
}

.design-d {
    color: red;
    margin-left: 5px;
    font-size: 18px;
}

.design-delete {
    display: none !important;
    cursor: pointer;
}

.design-edit {
    color: green;
}
</style>

<template>
    <div class="content-wrapper">
        <section class="content">
            <div class="box">
                <div class="box-header with-border" style="background: #d6d7d9">
                    <div class="heading-cart">
                        <div class="col-lg-12 col-md-12 no-padding">
                            <h3 class="box-title">Activity Exposure Time</h3>
                            <h3
                                class="box-title text-danger animated flash config-notif"
                                v-if="selectedBucketNameToImportConfig"
                            >
                                <b
                                    >Imported config from {{ selectedBucketNameToImportConfig }} Bucket. Click save to
                                    use the config.</b
                                >
                            </h3>
                        </div>
                        <div class="col-lg-12 col-md-12 no-padding">
                            <div class="col-md-9 col-lg-9"></div>
                            <div class="col-md-2 col-lg-2" style="display: inline-block; padding: 0px; margin: 0px">
                                <el-dropdown
                                    trigger="click"
                                    @command="selectBucketModule"
                                    style="float: right"
                                    v-if="!selectedBucketNameToImportConfig"
                                >
                                    <el-button type="primary" size="mini" :title="'Import Config'">
                                        Import Config<i class="el-icon-arrow-down el-icon--right"></i>
                                    </el-button>
                                    <el-dropdown-menu slot="dropdown" v-if="bucketListForModuleConfig.length > 0">
                                        <el-dropdown-item
                                            v-for="(bucket, index) in bucketListForModuleConfig"
                                            :command="index"
                                            :key="index"
                                            >{{ bucket.bucketName }}</el-dropdown-item
                                        >
                                    </el-dropdown-menu>
                                </el-dropdown>
                                <el-button
                                    type="danger"
                                    size="mini"
                                    :title="Reset"
                                    v-if="selectedBucketNameToImportConfig"
                                    v-on:click.prevent="removeSelectedModuleConfig()"
                                    style="min-width: 130px; float: right"
                                    >Reset
                                </el-button>
                            </div>
                            <div class="col-md-1 col-lg-1 no-padding">
                                <a
                                    href="#"
                                    class="btn-success"
                                    @click="saveAndPublishAxt()"
                                    style="background: #5cb85c; position: relative !important"
                                    >Save</a
                                >
                            </div>
                        </div>
                    </div>
                </div>
                <div class="box-body">
                    <div class="row">
                        <div class="col-lg-12 col-md-12">
                            <div class="col-lg-2 col-md-2">
                                <h3 class="box-title" style="display: block !important">Enable/Disable</h3>
                                <el-switch
                                    v-model="axtConfig.isEnabled"
                                    active-color="#13ce66"
                                    inactive-color="#ff4949"
                                    style="line-height: 35px !important"
                                >
                                </el-switch>
                            </div>
                            <div class="col-lg-3 col-md-3">
                                <h3 class="box-title" style="display: block !important">
                                    Ignore Ad-Unit Auto detection
                                </h3>
                                <el-switch
                                    v-model="axtConfig.activateWhitelist"
                                    active-color="#13ce66"
                                    inactive-color="#ff4949"
                                    style="line-height: 35px !important"
                                >
                                </el-switch>
                            </div>
                            <div class="col-lg-3 col-md-3 no-padding">
                                <h3 class="box-title" style="display: block !important">Initial exposure(sec)</h3>
                                <el-input placeholder="initial" v-model="axtConfig.initialExpo"></el-input>
                            </div>
                            <div class="col-lg-3 col-md-3">
                                <h3 class="box-title" style="display: block !important">Subsequent exposure(sec)</h3>
                                <el-input placeholder="sub-sequent" v-model="axtConfig.subSequentExpo"></el-input>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12 col-md-12" style="background: #d6d7d9; padding: 10px">
                            <div class="col-lg-11 col-md-11">
                                <h2 class="box-title">Direct Campaign Blocklist(Advertiser/Campaign ID)</h2>
                            </div>
                            <!-- <div class="col-lg-1 col-md-1">

<el-switch v-model="axtConfig.isEnabled" active-color="#13ce66" inactive-color="#ff4949" style="line-height: 15px !important;"></el-switch>

</div> -->
                        </div>
                        <div class="col-lg-12 col-md-12">
                            <template>
                                <el-table
                                    :data="axtDCBlockList"
                                    stripe
                                    height="200"
                                    style="width: 100%"
                                    v-loading="loading"
                                    @selection-change="handleDCSelectionChange"
                                >
                                    <el-table-column type="selection" width="30"> </el-table-column>
                                    <el-table-column
                                        prop="advertiser_id"
                                        :align="left"
                                        label="Advertiser/Campaign ID"
                                        width="600"
                                    >
                                    </el-table-column>
                                    <el-table-column label="IsBlocked" width="200">
                                        <template slot-scope="props">
                                            <div v-if="props.row.is_blocklisted" class="text-center">
                                                <svg
                                                    data-v-7a40f996=""
                                                    aria-hidden="true"
                                                    height="20px"
                                                    width="20px"
                                                    data-prefix="far"
                                                    data-icon="check-circle"
                                                    role="img"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 512 512"
                                                    class="svg-inline--fa fa-check-circle fa-w-16 fa-2x"
                                                >
                                                    <path
                                                        data-v-7a40f996=""
                                                        fill="green"
                                                        d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
                                                    ></path>
                                                </svg>
                                            </div>
                                            <div v-if="!props.row.is_blocklisted" class="text-center">
                                                <svg
                                                    aria-hidden="true"
                                                    height="20px"
                                                    width="20px"
                                                    data-prefix="fal"
                                                    data-icon="times-circle"
                                                    role="img"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 512 512"
                                                    class="svg-inline--fa fa-times-circle fa-w-16 fa-2x"
                                                >
                                                    <path
                                                        fill="red"
                                                        d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 464c-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216zm94.8-285.3L281.5 256l69.3 69.3c4.7 4.7 4.7 12.3 0 17l-8.5 8.5c-4.7 4.7-12.3 4.7-17 0L256 281.5l-69.3 69.3c-4.7 4.7-12.3 4.7-17 0l-8.5-8.5c-4.7-4.7-4.7-12.3 0-17l69.3-69.3-69.3-69.3c-4.7-4.7-4.7-12.3 0-17l8.5-8.5c4.7-4.7 12.3-4.7 17 0l69.3 69.3 69.3-69.3c4.7-4.7 12.3-4.7 17 0l8.5 8.5c4.6 4.7 4.6 12.3 0 17z"
                                                        class=""
                                                    ></path>
                                                </svg>
                                            </div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </template>
                        </div>
                        <div class="col-lg-12 col-md-12" style="padding: 3px" v-if="!enableDCConfigSetting">
                            <div class="col-md-10 col-lg-10">
                                <h3 class="box-title" style="display: block !important">Advertiser/Campaign ID</h3>
                                <el-input
                                    placeholder="Advertiser/Campaign Id"
                                    v-model="directCampConfig.advertId"
                                    style="margin-top: 7px !important"
                                ></el-input>
                            </div>
                            <div class="col-lg-2 col-md-2">
                                <button
                                    class="btn btn-md btn-primary btn-mt"
                                    @click="addAdvertiserIdtoBlock()"
                                    style="margin-top: 20px !important"
                                >
                                    Add
                                </button>
                            </div>
                        </div>
                        <!-- <div class="col-md-12 col-lg-12" style="padding: 3px;" v-if="enableDCConfigSetting">
                        <div class="col-md-10 col-lg-10">
                            <h3 class="box-title" style="display:block !important;">Block DC AdSpot</h3>
                            <el-switch v-model="multiSelectDCConfig.isBlocked" active-color="#13ce66" inactive-color="#ff4949" style="line-height: 30px !important;"></el-switch>
                        </div>
                        <div class="col-md-1 col-lg-1">
                            <button class="btn btn-md btn-primary btn-mt" @click="saveDCConfig()" style="margin-top: 20px !important;">save</button>
                        </div>
                    </div> -->
                        <div class="col-md-1 col-lg-1">
                            <button class="btn btn-md btn-danger btn-mt" @click="deleteSelectedDCId()" style="margin-top: 20px !important;">delete</button>
                        </div>
                    </div>

                    <div class="row">
                        <!-- <div class="col-lg-12 col-md-12" style="background: #d6d7d9;padding:10px;"> -->

                        <!-- <div class="col-lg-6 col-md-6">
                            <h3 class="box-title" style="display: block !important;">Add or Update Random size for AXT</h3>

                        </div> -->
                        <!-- <div class="col-md-6 col-lg-6"> -->

                        <!-- <div class="dbuttondiv"><button class="btn btn-danger" :disabled="checkedAll.length == 0" @click="deleteBlogAll">Delete Selected</button></div> -->
                        <!-- </div>
                    </div> -->
                        <!-- <div class="col-lg-12 col-md-12">
                        <div class="buckets">
                            <div v-show="israndomsize">

                                <div class="col-lg-12 col-md-12">
                                    <ul class="bucket-list clearfix">

                                        <li v-for="(obj, index)  in Object.keys(randomSizeList2)" class="shadowBox" v-bind:class="{ active: checkedAll.includes(obj) == true }" :key=index>
                                            <span>

                                                {{obj+':'+randomSizeList2[obj]}}

                                                <i class="fa fa-remove design-d design-delete" @click="deleteRandomSizeSingle(obj)"></i>
                                                <i class="fa fa-edit design-edit design-delete" @click="editRandomSize(obj)"></i>
                                                <el-checkbox @change="selectAll(obj)" v-model="isCheckedRandomSizeMap[obj]" :key="obj" class="design-delete"></el-checkbox>

                                            </span>
                                        </li>

                                    </ul>
                                </div>
                            </div>
                            <div v-show="!israndomsize">no random size</div>

                        </div>
                    </div> -->
                        <div class="col-lg-12 col-md-12">
                            <div class="row">
                                <div class="col-md-9">
                                    <!-- <el-input class="publisher-input" @input="filterByEachInput" type="text" v-model="randomSizeForm.randomSize"></el-input> -->
                                    <!-- <div class="duplicate">Note: If a Key already exists, will be overridden with the latest value</div> -->
                                </div>
                                <!-- <div class="col-md-3">

                                <button v-if="this.isedit" class="el-button el-button--success" type="submit" @click="saveBlog" :disabled="!randomSizeForm.randomSize">Edit</button>
                                <button v-else class="el-button el-button--success" type="submit" @click="saveBlog" :disabled="!randomSizeForm.randomSize">Add</button>
                            </div> -->
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-12 col-md-12" style="background: #d6d7d9; padding: 10px">
                            <div class="col-lg-11 col-md-11">
                                <h3 class="box-title" style="display: block !important">Tag Association</h3>
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12">
                            <div
                                class="col-lg-6 col-md-6"
                                v-for="(dimension, index) in axtConfig.associatedTags"
                                :key="index"
                            >
                                <div class="col-lg-3 col-md-3 no-padding" style="padding-top: 10px !important">
                                    <el-checkbox
                                        v-model="dimension.isChecked"
                                        :label="dimension.creativeSizeLable"
                                        size="small"
                                    ></el-checkbox>
                                </div>
                                <div class="col-lg-8 col-md-8 no-padding" style="margin-top: 3px">
                                    <el-select
                                        size="small"
                                        placeholder="Select Tag"
                                        filterable
                                        v-model="axtConfig.associatedTags[index].selectedTags"
                                    >
                                        <el-option
                                            v-for="tags in axtTags"
                                            :key="tags.id"
                                            :label="tags['dfp-ad-unit-path']"
                                            :value="tags.id"
                                            :selected="dimension.selectedTags == tags.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12 col-md-12" style="background: #d6d7d9; padding: 10px">
                            <div class="col-lg-11 col-md-11">
                                <h3 class="box-title">Ad-Unit specific configuration</h3>
                            </div>
                        </div>
                    </div>
                    <template>
                        <el-table
                            :data="axtConfigUnitList"
                            stripe
                            height="400"
                            style="width: 100%"
                            @selection-change="handleSelectionChange"
                            v-loading="loading"
                        >
                            <el-table-column type="selection" width="30"> </el-table-column>
                            <el-table-column
                                prop="layoutName"
                                sortable
                                :filters="filterList"
                                :filter-method="layoutFilterHandler"
                                label="Layout"
                                width="180"
                            >
                            </el-table-column>
                            <el-table-column prop="adSpotName" label="Ad Spot" width="180"> </el-table-column>
                            <el-table-column label="Block AXT" width="80">
                                <template slot-scope="props">
                                    <div v-if="props.row.isBlocked" class="text-center">
                                        <svg
                                            data-v-7a40f996=""
                                            aria-hidden="true"
                                            height="20px"
                                            width="20px"
                                            data-prefix="far"
                                            data-icon="check-circle"
                                            role="img"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 512 512"
                                            class="svg-inline--fa fa-check-circle fa-w-16 fa-2x"
                                        >
                                            <path
                                                data-v-7a40f996=""
                                                fill="green"
                                                d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
                                            ></path>
                                        </svg>
                                    </div>
                                    <div v-if="!props.row.isBlocked" class="text-center">
                                        <svg
                                            aria-hidden="true"
                                            height="20px"
                                            width="20px"
                                            data-prefix="fal"
                                            data-icon="times-circle"
                                            role="img"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 512 512"
                                            class="svg-inline--fa fa-times-circle fa-w-16 fa-2x"
                                        >
                                            <path
                                                fill="red"
                                                d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 464c-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216zm94.8-285.3L281.5 256l69.3 69.3c4.7 4.7 4.7 12.3 0 17l-8.5 8.5c-4.7 4.7-12.3 4.7-17 0L256 281.5l-69.3 69.3c-4.7 4.7-12.3 4.7-17 0l-8.5-8.5c-4.7-4.7-4.7-12.3 0-17l69.3-69.3-69.3-69.3c-4.7-4.7-4.7-12.3 0-17l8.5-8.5c4.7-4.7 12.3-4.7 17 0l69.3 69.3 69.3-69.3c4.7-4.7 12.3-4.7 17 0l8.5 8.5c4.6 4.7 4.6 12.3 0 17z"
                                                class=""
                                            ></path>
                                        </svg>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="Force AXT" width="80">
                                <template slot-scope="props">
                                    <div v-if="props.row.isWhitelisted" class="text-center">
                                        <svg
                                            data-v-7a40f996=""
                                            aria-hidden="true"
                                            height="20px"
                                            width="20px"
                                            data-prefix="far"
                                            data-icon="check-circle"
                                            role="img"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 512 512"
                                            class="svg-inline--fa fa-check-circle fa-w-16 fa-2x"
                                        >
                                            <path
                                                data-v-7a40f996=""
                                                fill="green"
                                                d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
                                            ></path>
                                        </svg>
                                    </div>
                                    <div v-if="!props.row.isWhitelisted" class="text-center">
                                        <svg
                                            aria-hidden="true"
                                            height="20px"
                                            width="20px"
                                            data-prefix="fal"
                                            data-icon="times-circle"
                                            role="img"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 512 512"
                                            class="svg-inline--fa fa-times-circle fa-w-16 fa-2x"
                                        >
                                            <path
                                                fill="red"
                                                d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 464c-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216zm94.8-285.3L281.5 256l69.3 69.3c4.7 4.7 4.7 12.3 0 17l-8.5 8.5c-4.7 4.7-12.3 4.7-17 0L256 281.5l-69.3 69.3c-4.7 4.7-12.3 4.7-17 0l-8.5-8.5c-4.7-4.7-4.7-12.3 0-17l69.3-69.3-69.3-69.3c-4.7-4.7-4.7-12.3 0-17l8.5-8.5c4.7-4.7 12.3-4.7 17 0l69.3 69.3 69.3-69.3c4.7-4.7 12.3-4.7 17 0l8.5 8.5c4.6 4.7 4.6 12.3 0 17z"
                                                class=""
                                            ></path>
                                        </svg>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="Initial(sec)" prop="initialExpo" width="120"> </el-table-column>
                            <el-table-column label="Subsequent(sec)" prop="subSeqExpo" width="120"> </el-table-column>
                            <el-table-column label="Ignore Activity" width="110">
                                <template slot-scope="props">
                                    <div v-if="props.row.ignoreActivity" class="text-center">
                                        <svg
                                            data-v-7a40f996=""
                                            aria-hidden="true"
                                            height="20px"
                                            width="20px"
                                            data-prefix="far"
                                            data-icon="check-circle"
                                            role="img"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 512 512"
                                            class="svg-inline--fa fa-check-circle fa-w-16 fa-2x"
                                        >
                                            <path
                                                data-v-7a40f996=""
                                                fill="green"
                                                d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
                                            ></path>
                                        </svg>
                                    </div>
                                    <div v-if="!props.row.ignoreActivity" class="text-center">
                                        <svg
                                            aria-hidden="true"
                                            height="20px"
                                            width="20px"
                                            data-prefix="fal"
                                            data-icon="times-circle"
                                            role="img"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 512 512"
                                            class="svg-inline--fa fa-times-circle fa-w-16 fa-2x"
                                        >
                                            <path
                                                fill="red"
                                                d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 464c-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216zm94.8-285.3L281.5 256l69.3 69.3c4.7 4.7 4.7 12.3 0 17l-8.5 8.5c-4.7 4.7-12.3 4.7-17 0L256 281.5l-69.3 69.3c-4.7 4.7-12.3 4.7-17 0l-8.5-8.5c-4.7-4.7-4.7-12.3 0-17l69.3-69.3-69.3-69.3c-4.7-4.7-4.7-12.3 0-17l8.5-8.5c4.7-4.7 12.3-4.7 17 0l69.3 69.3 69.3-69.3c4.7-4.7 12.3-4.7 17 0l8.5 8.5c4.6 4.7 4.6 12.3 0 17z"
                                                class=""
                                            ></path>
                                        </svg>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="Selected Tag ">
                                <template slot-scope="prop">
                                    <div>
                                        {{ getTag(axtTags, prop.row.tagId) }}
                                    </div>
                                </template>
                            </el-table-column>
                            <!-- <el-table-column label="Sub-sequent Tag-Override">

<template slot-scope="props">

<div v-if="props.row.tagOverride" class="text-center">

<svg data-v-7a40f996="" aria-hidden="true" height="20px" width="20px" data-prefix="far" data-icon="check-circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-check-circle fa-w-16 fa-2x"><path data-v-7a40f996="" fill="green" d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"></path></svg>

</div>

<div v-if="!props.row.tagOverride" class="text-center">

<svg aria-hidden="true" height="20px" width="20px" data-prefix="fal" data-icon="times-circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-times-circle fa-w-16 fa-2x"><path fill="red" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 464c-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216zm94.8-285.3L281.5 256l69.3 69.3c4.7 4.7 4.7 12.3 0 17l-8.5 8.5c-4.7 4.7-12.3 4.7-17 0L256 281.5l-69.3 69.3c-4.7 4.7-12.3 4.7-17 0l-8.5-8.5c-4.7-4.7-4.7-12.3 0-17l69.3-69.3-69.3-69.3c-4.7-4.7-4.7-12.3 0-17l8.5-8.5c4.7-4.7 12.3-4.7 17 0l69.3 69.3 69.3-69.3c4.7-4.7 12.3-4.7 17 0l8.5 8.5c4.6 4.7 4.6 12.3 0 17z" class=""></path></svg>

</div>

</template>

</el-table-column> -->
                            <el-table-column label="Multisize Dimension(WxH)">
                                <template slot-scope="prop">
                                    <div>
                                        {{ getDimensionLable(prop.row.multiSize) }}
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </template>
                    <div class="row clearfix">
                        <div class="col-lg-12 col-md-12 no-padding" v-if="multiSelectedUnits.length == 0">
                            <div class="col-lg-5 col-md-5">
                                <h3 class="box-title">Layout</h3>
                                <el-select
                                    v-model="setUnitConfig.layout"
                                    filterable
                                    placeholder="Select a Layout"
                                    @change="getAdSpots"
                                >
                                    <el-option
                                        v-for="layout in layoutsList"
                                        :key="layout.id"
                                        :label="layout.layout_name"
                                        :value="layout.id"
                                    ></el-option>
                                </el-select>
                            </div>
                            <div class="col-lg-5 col-md-5">
                                <h3 class="box-title">Ad Spot</h3>
                                <el-select
                                    v-model="setUnitConfig.layoutAdSpots"
                                    filterable
                                    placeholder="Select a AdSpot"
                                >
                                    <el-option
                                        v-for="adSpot in layoutAdSpotsList"
                                        :key="adSpot.id"
                                        :label="adSpot.adSpot"
                                        :value="adSpot.id"
                                    ></el-option>
                                </el-select>
                            </div>
                            <div class="col-lg-2 col-md-2">
                                <button class="btn btn-md btn-primary btn-mt" @click="addUnitToConfigList()">
                                    Add
                                </button>
                            </div>
                        </div>
                        <div class="col-md-12 col-lg-12 no-padding" v-if="multiSelectedUnits.length > 0">
                            <div class="col-md-1 col-lg-1">
                                <h3 class="box-title" style="display: block !important">Block AXT</h3>
                                <el-switch
                                    :disabled="multiSelectConfig.isWhitelisted"
                                    v-model="multiSelectConfig.isBlocked"
                                    active-color="#13ce66"
                                    inactive-color="#ff4949"
                                    style="line-height: 30px !important"
                                ></el-switch>
                            </div>
                            <div class="col-md-1 col-lg-1">
                                <h3 class="box-title" style="display: block !important">Force AXT</h3>
                                <el-switch
                                    :disabled="multiSelectConfig.isBlocked"
                                    v-model="multiSelectConfig.isWhitelisted"
                                    active-color="#13ce66"
                                    inactive-color="#ff4949"
                                    style="line-height: 30px !important"
                                ></el-switch>
                            </div>
                            <div class="col-md-2 col-lg-2">
                                <h3 class="box-title" style="display: block !important">Initial exposure(sec)</h3>
                                <el-input
                                    :disabled="multiSelectConfig.isBlocked"
                                    placeholder="Initial"
                                    v-model="multiSelectConfig.initialExpo"
                                ></el-input>
                            </div>
                            <div class="col-md-2 col-lg-2">
                                <h3 class="box-title" style="display: block !important">Subsequent exposure(sec)</h3>
                                <el-input
                                    :disabled="multiSelectConfig.isBlocked"
                                    placeholder="Subsequent"
                                    v-model="multiSelectConfig.subSeqExpo"
                                ></el-input>
                            </div>
                            <div class="col-md-2 col-lg-2">
                                <h3 class="box-title" style="display: block !important">Select Tag</h3>
                                <el-select
                                    size="small"
                                    class="tag-dropdown"
                                    clearable
                                    placeholder="Select Tag"
                                    filterable
                                    v-model="multiSelectConfig.tagId"
                                    :disabled="multiSelectConfig.isBlocked"
                                >
                                    <el-option
                                        v-for="tags in axtTags"
                                        :key="tags.id"
                                        :label="tags['dfp-ad-unit-path']"
                                        :value="tags.id"
                                        :selected="multiSelectConfig.tagId == tags.id"
                                    >
                                    </el-option>
                                </el-select>
                            </div>
                            <!-- <div class="col-md-1 col-lg-1" >

<h3 class="box-title" style="display:block !important;">Sub-sequent Tag override</h3>

<el-switch :disabled="!multiSelectConfig.tagId" v-model="multiSelectConfig.tagOverride" active-color="#13ce66" inactive-color="#ff4949" style="line-height: 30px !important;"></el-switch>

</div> -->
                            <div class="col-md-2 col-lg-2">
                                <h3 class="box-title" style="display: block !important">Multisize (W X H)</h3>
                                <el-select
                                    size="small"
                                    class="tag-dropdown"
                                    clearable
                                    placeholder="W X H"
                                    filterable
                                    v-model="multiSelectConfig.multiSize"
                                    :disabled="multiSelectConfig.isBlocked"
                                >
                                    <el-option
                                        v-for="dimension in creativeSizeList"
                                        :key="dimension.id"
                                        :label="dimension.width + 'x' + dimension.height"
                                        :value="dimension.id"
                                        :selected="multiSelectConfig.multiSize == dimension.id"
                                    >
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="col-md-1 col-lg-1">
                                <h3 class="box-title" style="display: block !important">Ignore Activity</h3>
                                <el-switch
                                    :disabled="multiSelectConfig.isBlocked"
                                    v-model="multiSelectConfig.ignoreActivity"
                                    active-color="#13ce66"
                                    inactive-color="#ff4949"
                                    style="line-height: 30px !important"
                                ></el-switch>
                            </div>
                        </div>
                        <div class="col-md-12 col-lg-12 no-padding" v-if="multiSelectedUnits.length > 0">
                            <div class="col-md-1 col-lg-1 no-padding text-center">
                                <a
                                    href="#"
                                    class="btn btn-success"
                                    @click="saveUnitConfiguration()"
                                    style="
                                        background: #5cb85c;
                                        position: relative !important;
                                        margin-top: 10px !important;
                                    "
                                    >Apply</a
                                >
                            </div>
                            <div class="col-md-1 col-lg-1 no-padding text-center">
                                <a
                                    href="#"
                                    class="btn btn-danger"
                                    @click="deleteAdSpotFromConfig()"
                                    style="position: relative !important; margin-top: 10px !important"
                                    >Delete</a
                                >
                            </div>
                            <div class="col-md-1 col-lg-1 no-padding text-center">
                                <a
                                    href="#"
                                    class="btn btn-primary"
                                    style="position: relative !important; margin-top: 10px !important"
                                    >Cancel</a
                                >
                                <!-- <a href="#" class="btn btn-primary" @click="" style="position:relative !important;margin-top: 10px !important;">Cancel</a> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import axios from 'axios';
import { isArray } from 'util';
export default {
    data() {
        return {
            module: 'axt',
            bucketId: undefined,
            randomSizeForm: {
                randomSize: '',
            },
            axtConfig: {
                isEnabled: false,
                initialExpo: 15,
                subSequentExpo: 15,
                associatedTags: [],
                selectedCreative: undefined,
                selectedTags: undefined,
                existingCreatives: [],
                showAddMoreCreative: false,
                activateWhitelist: false,
            },
            layoutsList: [],

            layoutAdSpotsList: [],
            setUnitConfig: {
                layout: undefined,
                layoutAdSpots: undefined,
            },
            adunits: [],
            axtTags: [],
            randomSizeList: {},
            randomSizeList2: {},
            creativeSizeList: [],
            bucketListForModuleConfig: [],
            selectedBucketToImportConfig: undefined,
            selectedBucketNameToImportConfig: undefined,
            axtConfigUnitList: [],
            filterList: [],
            multiSelectConfig: {
                isBlocked: false,
                isWhitelisted: false,
                initialExpo: undefined,
                subSeqExpo: undefined,
                ignoreActivity: false,
                tagId: '',
                tagOverride: false,
                multiSize: '',
            },
            multiSelectedUnits: [],
            enableConfigSetting: false,
            loading: false,
            directCampConfig: {
                advertId: '',
            },
            axtDCBlockList: [],
            addAxtDCBlockList: [],
            multiSelectedDCUnits: [],
            multiSelectDCConfig: {
                isBlocked: false,
            },
            enableDCConfigSetting: false,
            subsequentReload: true,
            isedit: false,
            israndomsize: false,
            data_to_be_updated: {},
            checkedAll: [],
            messageb: '',
            isCheckedRandomSizeMap: [],
            isRandomValid: '/[0-9]*X[0-9]*/g',
        };
    },

    created: function () {
        this.bucketId = this.$route.params.bucketId;
        this.$nextTick(function () {
            this.getListOfBucketConfig();
            this.getAxtConfig(this.$route.params.bucketId);
            this.getUnitConfigList(this.bucketId);
            this.getDirectCampaignBlockList();
        });
    },
    methods: {
        filterByEachInput() {
            var input = this.randomSizeForm.randomSize;
            this.duplicatekey = ' ';
            this.isDuplicate = false;
            if (input.length == 0) {
                this.randomSizeList2 = this.randomSizeList;
                this.isedit = false;
                return;
            }
            var keyres = input.includes(':');
            if (keyres) {
                var sizeInputObj = this.convertSizeInputStringFromObject(input);
            }

            const regex = new RegExp(`^${input}`);
            const randomSizeList2 = Object.keys(this.randomSizeList)
                .filter((key) => {
                    return regex.test(key);
                })
                .reduce((obj, key) => {
                    obj[key] = this.randomSizeList[key];
                    return obj;
                }, {});
            if (Object.keys(randomSizeList2).length != 0) {
                this.randomSizeList2 = randomSizeList2;
            } else {
                this.randomSizeList2 = this.randomSizeList;
            }
            return randomSizeList2;
        },
        deleteRandomSizeSingle(key_AsPerameterOf_delete) {
            var randomSizeMap = {};
            randomSizeMap[key_AsPerameterOf_delete] = this.randomSizeList2[key_AsPerameterOf_delete];
            let x = {
                bucketId: this.bucketId,
                randomSize: randomSizeMap,
            };
            axios
                .post(BASE_URL + 'v1/delete_axt_random_size/', x)
                .then((response) => {
                    delete this.randomSizeList2[key_AsPerameterOf_delete];
                    this.randomSizeList = {};
                    Object.assign(this.randomSizeList, this.randomSizeList2);
                    this.$forceUpdate();
                })
                .catch((e) => {
                    this.errors.push(e);
                });
        },
        editRandomSize(key_AsPerameterOf_edit) {
            this.isedit = true;
            key_AsPerameterOf_edit = key_AsPerameterOf_edit + ':' + this.randomSizeList2[key_AsPerameterOf_edit];
            this.randomSizeForm.randomSize = key_AsPerameterOf_edit;
            var key_for_data_to_be_updated = key_AsPerameterOf_edit.split(':');
            this.data_to_be_updated[key_for_data_to_be_updated[0]] = key_for_data_to_be_updated[1];
        },
        selectAll(randomSizeObj) {
            var key = Object.keys(this.isCheckedRandomSizeMap);
            for (var i = 0; i < key.length; i++) {
                var k = key[i];
                if (this.isCheckedRandomSizeMap[k] == true) {
                    if (this.checkedAll.includes(key[i]) == false) {
                        this.checkedAll.push(key[i]);
                    }
                } else {
                    for (var j = 0; j < this.checkedAll.length; j++) {
                        if (this.checkedAll[j] == k) {
                            delete this.checkedAll[j];
                            break;
                        }
                    }
                }
            }
        },
        deleteBlogAll() {
            let x = {
                bucketId: this.bucketId,
                randomSize: this.checkedAll,
            };
            axios
                .post(BASE_URL + 'v1/delete_axt_random_size/', x)
                .then((response) => {
                    for (var i = 0; i < this.checkedAll.length; i++) {
                        delete this.randomSizeList2[this.checkedAll[i]];
                    }
                    this.randomSizeList = {};
                    Object.assign(this.randomSizeList, this.randomSizeList2);
                    while (this.checkedAll.length) {
                        this.checkedAll.pop();
                    }
                    this.isCheckedRandomSizeMap = [];
                    this.$forceUpdate();
                })
                .catch((e) => {
                    this.errors.push(e);
                });
        },
        myTrim(x) {
            return x.replace(/\s/g, '');
        },
        convertSizeInputStringFromObject(sizeInput) {
            var value;
            var sizeInputObj = {};
            sizeInput = this.myTrim(sizeInput);
            var regex = /[^\w | \, | \:]/g;
            sizeInput = sizeInput.replace(regex, '');
            if (sizeInput.indexOf(',') > -1) {
                var nameArr = sizeInput.split(',');
                nameArr.filter((val) => {
                    value = val.split(':');
                    sizeInputObj[value[0]] = value[1];
                });
            } else {
                value = sizeInput.split(':');
                sizeInputObj[value[0]] = value[1];
            }
            return sizeInputObj;
        },
        saveBlog() {
            var sizeInput = this.randomSizeForm.randomSize;
            var sizeInputObj = this.convertSizeInputStringFromObject(sizeInput);
            sizeInputObj = this.getFilterAxtRandomSize(sizeInputObj);
            // logic for update
            if (this.isedit) {
                if (Object.keys(sizeInputObj).length == 0) {
                    return;
                }
                let y = {
                    bucketId: this.bucketId,
                    data_to_be_updated: this.data_to_be_updated,
                    randomSize: sizeInputObj,
                };
                axios
                    .post(BASE_URL + 'v1/update_axt_random_size/', y)
                    .then((response) => {
                        var keysz = Object.keys(this.data_to_be_updated);
                        delete this.randomSizeList2[keysz[0]];
                        for (var key in sizeInputObj) {
                            this.$set(this.randomSizeList2, key, sizeInputObj[key]);
                        }
                        this.randomSizeList = {};
                        Object.assign(this.randomSizeList, this.randomSizeList2);
                        this.data_to_be_updated = {};
                        this.isedit = false;
                    })
                    .catch((e) => {
                        this.errors.push(e);
                    });
                this.randomSizeForm.randomSize = '';
                return;
            }
            // logic for add
            let x = {
                bucketId: this.bucketId,
                randomSize: sizeInputObj,
            };
            axios
                .post(BASE_URL + 'v1/add_axt_random_size/', x)
                .then((response) => {
                    for (var key in sizeInputObj) {
                        this.$set(this.randomSizeList2, key, sizeInputObj[key]);
                        this.randomSizeList2 = JSON.parse(JSON.stringify(this.randomSizeList2));
                    }
                    this.randomSizeList = {};
                    Object.assign(this.randomSizeList, this.randomSizeList2);
                    this.data_to_be_updated = {};
                    this.israndomsize = true;
                })
                .catch((e) => {
                    this.errors.push(e);
                });
            this.randomSizeForm.randomSize = '';
        },

        getFilterAxtRandomSize: function (sizeInputObj) {
            var isValid = /^\d+X\d+$/;
            var ObjectRight = {};
            var ObjectNotRight = {};
            for (var key in sizeInputObj) {
                var keyres = isValid.test(key);
                var valueres = isValid.test(sizeInputObj[key]);
                if (keyres == true && valueres == true) {
                    ObjectRight[key] = sizeInputObj[key];
                } else {
                    ObjectNotRight[key] = sizeInputObj[key];
                }
            }
            var ar = ObjectNotRight;
            if (Object.keys(ar).length != 0) {
                ar = JSON.stringify(ar);
                this.$notify({
                    title: 'warning',
                    message: ar,
                    type: 'warning',
                });
            } else {
                this.$notify({
                    title: 'success',
                    message: 'success',
                    type: 'success',
                });
            }
            return ObjectRight;
        },
        getTag: function (arr, index) {
            let reqVal = arr.filter((val) => {
                if (val.id == index) {
                    return val;
                }
            });
            if (reqVal.length == 0) {
                return 'No Tags associated';
            } else {
                return reqVal[0]['dfp-ad-unit-path'];
            }
        },
        getSelecteditem: function (event, tagId) {
            console.log('test');
            console.log(tagId.adSpotName);
            console.log(event);
        },
        notificationMsg: function (type = 'Error', msg) {
            this.$notify({
                title: type,
                message: msg ? msg : 'Oops Something went wrong!',
                type: type.toLowerCase(),
            });
        },
        getListOfBucketConfig: function () {
            axios
                .post(BASE_URL + 'v1/get_bucket_config_list/', {
                    bucketId: this.bucketId,
                    module: this.module,
                })
                .then((response) => {
                    if (response.data.response_data.status) {
                        this.bucketListForModuleConfig = response.data.response_data.bucket_list;
                    }
                })
                .catch((e) => {
                    console.log();
                });
        },
        getAxtConfig: function (bucketId) {
            axios
                .post(BASE_URL + 'v1/axt_module/', {
                    bucketId: bucketId,
                })
                .then((response) => {
                    this.axtConfig = response.data.data.axt_configuration;
                    this.creativeSizeList = response.data.data.ad_dimensions;
                    this.axtTags = response.data.data.axt_ad_tags;
                    this.layoutsList = response.data.data.domain_layouts;
                    this.randomSizeList2 = response.data.data.axt_random_size[0].random_size;
                    this.randomSizeList = response.data.data.axt_random_size[0].random_size;
                    if (this.randomSizeList2) {
                        this.israndomsize = true;
                    }
                })
                .catch((e) => {
                    this.errors.push(e);
                });
        },
        saveAndPublishAxt: function () {
            var valid = true;
            if (valid && parseInt(this.axtConfig.initialExpo) < 5) {
                valid = false;
                this.notificationMsg('Warning', "Initial Exposure time should be greater than or equal to 5sec's.");
            }

            if (valid && parseInt(this.axtConfig.subSequentExpo) < 5) {
                valid = false;
                this.notificationMsg('Warning', "Sub-sequent Exposure time should be greater than or equal to 5sec's.");
            }

            if (valid) {
                var i = 0,
                    idx = this.axtConfig.associatedTags.length;
                for (; i < idx; i++) {
                    if (this.axtConfig.associatedTags[i].isChecked && !this.axtConfig.associatedTags[i].selectedTags) {
                        this.notificationMsg(
                            'Warning',
                            'Associate Tag for the selected Creative size ' +
                                this.axtConfig.associatedTags[i].creativeSizeLable
                        );
                        valid = false;
                        return false;
                    }
                }
            }

            if (valid) {
                var requestData = {
                    bucketId: this.bucketId,
                    isEnabled: this.axtConfig.isEnabled,
                    initialExpo: this.axtConfig.initialExpo,
                    subExpo: this.axtConfig.subSequentExpo,
                    associatedTags: this.axtConfig.associatedTags,
                    activateWhitelist: this.axtConfig.activateWhitelist ? this.axtConfig.activateWhitelist : false,
                    tagId: this.axtConfig.tagId ? this.axtConfig.tagId : '',
                };
                axios
                    .post(BASE_URL + 'v1/create_axt_unit/', requestData)
                    .then((response) => {
                        console.log(response);
                        if (response.data.response_data.status) {
                            if (this.selectedBucketToImportConfig) {
                                this.importAxtConfig();
                            } else {
                                this.updateConfig();
                            }
                            this.notificationMsg('Success', response.data.response_data.message);
                            this.getAxtConfig(this.bucketId);
                        } else {
                            this.notificationMsg('Error', response.data.response_data.message);
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                        // this.errors.push(e);
                    });
            }
        },
        selectBucketModule(index) {
            this.selectedBucketToImportConfig = this.bucketListForModuleConfig[index].id;
            this.selectedBucketNameToImportConfig = this.bucketListForModuleConfig[index].bucketName;
            if (this.selectedBucketToImportConfig !== null && this.selectedBucketToImportConfig !== undefined) {
                this.getAxtConfig(this.selectedBucketToImportConfig);
                this.getUnitConfigList(this.selectedBucketToImportConfig);
                this.notificationMsg('Success', 'Imported Successfully! click save to use this config.');
            }
        },
        removeSelectedModuleConfig() {
            this.selectedBucketNameToImportConfig = undefined;
            this.getAxtConfig(this.bucketId);
            this.getUnitConfigList(this.bucketId);
        },
        getAdSpots(query) {
            if (query) {
                var requestData = {
                    layoutId: query,
                };
                axios
                    .post(BASE_URL + 'v1/get_layout_adspots/', requestData)
                    .then((response) => {
                        this.layoutAdSpotsList = response.data.data;
                    })
                    .catch((e) => {
                        this.errors.push(e);
                    });
            }
        },
        getUnitConfigList(bucketId) {
            axios
                .post(BASE_URL + 'v1/get_axt_config_unit_list/', {
                    bucketId: bucketId,
                })
                .then((response) => {
                    console.log('testing', response);
                    this.axtConfigUnitList = response.data.data;
                    this.axtConfigUnitList.tagId = '12';
                    var i = 0,
                        listOfArry = response.data.layoutsList,
                        idx = listOfArry.length;
                    this.filterList = [];
                    for (; i < idx; i++) {
                        this.filterList.push({
                            text: listOfArry[i],
                            value: listOfArry[i],
                        });
                    }
                })
                .catch((e) => {
                    this.errors.push(e);
                });
        },
        addUnitToConfigList() {
            var valid = true,
                requestData = {
                    bucketId: this.bucketId,
                    layout: this.setUnitConfig.layout || '',
                    adSpotId: this.setUnitConfig.layoutAdSpots || '',
                };
            if (!this.setUnitConfig.layout || !this.setUnitConfig.layoutAdSpots) {
                valid = false;
                this.notificationMsg('Warning', 'Layout and AdSpot is required!');
            }

            if (valid) {
                this.setUnitConfig.layout = this.setUnitConfig.layoutAdSpots = undefined;
                axios
                    .post(BASE_URL + 'v1/add_axt_unit_config_to_list/', requestData)
                    .then((response) => {
                        var statusMsg = response.data.status ? 'Success' : 'Error';
                        this.notificationMsg(statusMsg, response.data.message);
                        if (response.data.status) {
                            this.getUnitConfigList(this.bucketId);
                        }
                    })
                    .catch((e) => {
                        this.errors.push(e);
                    });
            }
        },
        handleSelectionChange(selectedAdSpot) {
            this.multiSelectedUnits = selectedAdSpot;
            this.enableConfigSetting = this.multiSelectedUnits.length > 0 ? true : false;
            if (this.multiSelectedUnits.length == 1) {
                this.multiSelectConfig = {
                    isBlocked: this.multiSelectedUnits[0]['isBlocked'],
                    isWhitelisted: this.multiSelectedUnits[0]['isWhitelisted'],
                    initialExpo: this.multiSelectedUnits[0]['initialExpo'],
                    subSeqExpo: this.multiSelectedUnits[0]['subSeqExpo'],
                    ignoreActivity: this.multiSelectedUnits[0]['ignoreActivity'],
                    tagId: this.multiSelectedUnits[0]['tagId'],
                    tagOverride: this.multiSelectedUnits[0]['tagOverride'],
                    multiSize: this.multiSelectedUnits[0]['multiSize'],
                };
            } else {
                this.multiSelectConfig = {
                    isBlocked: false,
                    isWhitelisted: false,
                    initialExpo: 0,
                    subSeqExpo: 0,
                    ignoreActivity: false,
                    tagId: '',
                    tagOverride: false,
                    multiSize: '',
                };
            }
        },
        layoutFilterHandler(value, row, column) {
            return row['layoutName'] === value;
        },
        deleteAdSpotFromConfig() {
            var i = 0,
                idx = this.multiSelectedUnits.length,
                deleteUnits = [];
            for (; i < idx; i++) {
                deleteUnits.push(this.multiSelectedUnits[i].id);
            }

            if (deleteUnits.length > 0) {
                var requestData = {
                    bucketId: this.bucketId,
                    selectedUnit: deleteUnits,
                };
                axios
                    .post(BASE_URL + 'v1/delete_configured_units/', requestData)
                    .then((response) => {
                        var statusMsg = response.data.status ? 'Success' : 'Error';
                        this.notificationMsg(statusMsg, response.data.message);
                        if (response.data.status) {
                            this.getUnitConfigList(this.bucketId);
                        }
                    })
                    .catch((e) => {
                        this.errors.push(e);
                    });
            } else {
                this.notificationMsg('Warning', 'Select atleast one ADSpot to delete.');
            }
        },
        saveUnitConfiguration() {
            if (this.multiSelectedUnits.length > 0) {
                var valid = true;
                if (
                    !this.multiSelectConfig.isBlocked &&
                    this.multiSelectConfig.initialExpo !== undefined &&
                    this.multiSelectConfig.subSeqExpo !== undefined
                ) {
                    if (
                        !this.multiSelectConfig.ignoreActivity &&
                        (this.multiSelectConfig.initialExpo < 5 || this.multiSelectConfig.subSeqExpo < 5)
                    ) {
                        valid = false;
                        this.notificationMsg(
                            'Warning',
                            'Initial and Subsequent Exposure time should be greater than or equal to 5sec.'
                        );
                    } else if (this.multiSelectConfig.ignoreActivity && this.multiSelectConfig.initialExpo < 5) {
                        valid = false;
                        this.notificationMsg('Warning', 'AdFocus timer should be greater than or equal to 5sec.');
                    }
                }

                if (valid) {
                    var i = 0,
                        idx = this.multiSelectedUnits.length;
                    for (; i < idx; i++) {
                        if (this.multiSelectConfig.isBlocked) {
                            this.multiSelectedUnits[i]['isBlocked'] = this.multiSelectConfig.isBlocked;
                            this.multiSelectedUnits[i]['isWhitelisted'] = false;
                            this.multiSelectedUnits[i]['tagId'] = '';
                            this.multiSelectedUnits[i]['tagOverride'] = false;
                            this.multiSelectedUnits[i]['initialExpo'] = 0;
                            this.multiSelectedUnits[i]['subSeqExpo'] = 0;
                            this.multiSelectedUnits[i]['ignoreActivity'] = false;
                            this.multiSelectedUnits[i]['multiSize'] = '';
                        } else {
                            this.multiSelectedUnits[i]['isBlocked'] = false;
                            this.multiSelectedUnits[i]['isWhitelisted'] = this.multiSelectConfig.isWhitelisted;
                            this.multiSelectedUnits[i]['tagId'] = this.multiSelectConfig.tagId;
                            this.multiSelectedUnits[i]['tagOverride'] = this.multiSelectConfig.tagOverride;
                            this.multiSelectedUnits[i]['initialExpo'] = this.multiSelectConfig.initialExpo;
                            if(this.multiSelectConfig.ignoreActivity && this.multiSelectConfig.subSeqExpo > 0) {
                                this.notificationMsg('Info', "Can't have subSeqExpo > 0 when ignoreActivity enabled.");
                            }
                            this.multiSelectedUnits[i]['subSeqExpo'] = this.multiSelectConfig.ignoreActivity
                                ? 0
                                : this.multiSelectConfig.subSeqExpo;
                            this.multiSelectedUnits[i]['ignoreActivity'] = this.multiSelectConfig.ignoreActivity;
                            this.multiSelectedUnits[i]['multiSize'] = this.multiSelectConfig.multiSize;
                        }
                        if (i == idx - 1) {
                            this.multiSelectConfig.isBlocked =
                                this.multiSelectConfig.isWhitelisted =
                                this.multiSelectConfig.ignoreActivity =
                                    false;
                            this.multiSelectConfig.initialExpo = this.multiSelectConfig.subSeqExpo = 0;
                            this.multiSelectConfig.tagId = '';
                            this.multiSelectConfig.multiSize = '';
                            this.multiSelectConfig.tagOverride = false;
                        }
                    }
                }
            } else {
                this.notificationMsg('Warning', 'Select atleast one ADSpot to update configuration.');
            }
        },
        updateConfig() {
            var requestData = {
                bucketId: this.bucketId,
                configList: this.axtConfigUnitList,
            };
            axios
                .post(BASE_URL + 'v1/set_axt_config_unit_list/', requestData)
                .then((response) => {
                    console.log(response);
                    var statusMsg = response.data.status ? 'Success' : 'Error';
                    this.notificationMsg(statusMsg, response.data.message);
                    if (response.data.status) {
                        this.getUnitConfigList(this.bucketId);
                    }
                })
                .catch((e) => {
                    this.errors.push(e);
                });
        },
        importAxtConfig() {
            var requestData = {
                bucketId: this.bucketId,
                configList: this.axtConfigUnitList,
            };
            console.log('Imported config for AXT module');
            axios
                .post(BASE_URL + 'v1/import_axt_config_unit_list/', requestData)
                .then((response) => {
                    var statusMsg = response.data.status ? 'Success' : 'Error';
                    this.notificationMsg(statusMsg, response.data.message);
                    if (response.data.status) {
                        this.getUnitConfigList(this.bucketId);
                    }
                })
                .catch((e) => {
                    this.errors.push(e);
                });
        },
        getDimensionLable(id) {
            var i = 0,
                idx = this.creativeSizeList.length,
                selectedDimensionLable = 'No Multi Size Tag associated.';
            if (id !== undefined) {
                for (; i < idx; i++) {
                    if (this.creativeSizeList[i]['id'] === id) {
                        return this.creativeSizeList[i]['width'] + 'X' + this.creativeSizeList[i]['height'];
                    }
                }
            }
            return selectedDimensionLable;
        },
        addAdvertiserIdtoBlock() {
            if (!this.directCampConfig['advertId']) {
                this.notificationMsg('Warning', 'Advertiser/Campaign ID is required to Block.');
            } else {
                axios
                    .post(BASE_URL + 'v1/set_axt_direct_campaign_block_list/', {
                        bucketId: this.bucketId,
                        advertiserId: this.directCampConfig['advertId'],
                        status: true,
                    })
                    .then((response) => {
                        var statusMsg = response.data.status ? 'Success' : 'Error';
                        this.notificationMsg(statusMsg, response.data.message);
                        if (response.data.status) {
                            this.directCampConfig['advertId'] = '';
                            this.getDirectCampaignBlockList();
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                    });
            }
        },
        getDirectCampaignBlockList() {
            axios
                .post(BASE_URL + 'v1/get_axt_direct_campaign_list/', {
                    bucketId: this.bucketId,
                })
                .then((response) => {
                    if (response.data.status) {
                        this.axtDCBlockList = response.data.data;
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        handleDCSelectionChange(selectedDCId) {
            this.multiSelectedDCUnits = selectedDCId;
            this.enableDCConfigSetting = this.multiSelectedDCUnits.length > 0 ? true : false;
            if (this.multiSelectedDCUnits.length == 1) {
                this.multiSelectDCConfig = {
                    isBlocked: this.multiSelectedDCUnits[0]['is_blocklisted'],
                };
            } else {
                this.multiSelectDCConfig = {
                    isBlocked: false,
                };
            }
        },
        deleteSelectedDCId() {
            axios
                .post(BASE_URL + 'v1/delete_direct_campaign_block_list/', {
                    listToDel: this.multiSelectedDCUnits,
                })
                .then((response) => {
                    var statusMsg = response.data.status ? 'Success' : 'Error';
                    this.notificationMsg(statusMsg, response.data.message);
                    if (response.data.status) {
                        this.getDirectCampaignBlockList();
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        saveDCConfig() {
            axios
                .post(BASE_URL + 'v1/update_direct_campaign_block_list/', {
                    listToUpdate: this.multiSelectedDCUnits,
                    isBlocked: this.multiSelectDCConfig.isBlocked,
                })
                .then((response) => {
                    var statusMsg = response.data.status ? 'Success' : 'Error';
                    this.notificationMsg(statusMsg, response.data.message);
                    if (response.data.status) {
                        this.getDirectCampaignBlockList();
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        },
    },
};
</script>
<style type='text/css'>
.tag-dropdown .el-input--small input.el-input__inner {
    height: 40px;
}
</style>
<style scoped>
.config-notif {
    /*position: fixed;

z-index: 999999999;

top:0;

margin-left: 100px !important;*/
}

.flash {
    background: none !important;
    padding: 0px 20px !important;
}

.content-wrapper .content {
    padding-top: 95px;
}

.el-select {
    display: block;
}

ul.bucket-list {
    display: block;
    padding: 0;
    margin: 0;
}

ul.bucket-list li.buckets {
    display: inline-block;
    padding: 5px 20px;
    background: #7c6eb8;
    border-radius: 40px;
    margin-right: 10px;
}

ul.bucket-list li.buckets span {
    color: #ffffff;
}

ul.bucket-list li.no-result {
    display: block;
}

.box-body {
    padding: 15px !important;
}

.heading-cart {
    padding: unset !important;
    border: unset !important;
    position: relative;
    margin: 0 0 15px 0 !important;
}

.configuration-box {
    min-height: 150px !important;
    max-height: 150px !important;
    overflow-x: scroll !important;
}

.box-title {
    display: inline-block;
    font-size: 12px;
    margin: 0;
    line-height: 1;
}

.row {
    /*border-top: 1px solid #eee !important;*/
    padding-top: 10px !important;
}

.btn-mt {
    margin-top: 28px !important;
}

.no-padding {
    padding: 0px !important;
}

.btn-circle {
    border-radius: 100px !important;
}

.text-grey {
    color: #e6e6e6 !important;
}

.el-button {
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    max-width: 130px !important;
    -webkit-line-clamp: 2 !important;
    -webkit-box-orient: vertical !important;
}

input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin: 0;
}

.el-switch {
    position: relative;
    line-height: 10px !important;
    height: 20px;
    vertical-align: middle;
}

.el-table {
    font-size: 12px !important;
}

#saveConfig {
    min-width: 130px !important;
    text-align: center !important;
}
</style>



// WEBPACK FOOTER //
// AxtModule.vue?daf60460